var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{attrs:{"parent":"services"}},[(_vm.$store.getters.getPermissions.permissionGod === true)?_c('tab',{attrs:{"id":"blocked_simcard","name":_vm.translate('services.blocked_simcard.title'),"href":_vm.url+'blocked_simcard?status=1&simcard_profile_status=2'}},[_c('BlockedSimcard')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }